import { render, staticRenderFns } from "./OverwatchDashboard.vue?vue&type=template&id=28245ef4&scoped=true"
import script from "./OverwatchDashboard.vue?vue&type=script&lang=js"
export * from "./OverwatchDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28245ef4",
  null
  
)

export default component.exports